<div class="contenedorInt">
<div class="contenedorIntHeader">
    <header class="FheaderInt" id="HquienesSomos">
        <div class="textHeader flx">
            <div class="dUno dmMedio"></div>
            <div class="dSeis dtOcho dmOnce">
                <h1>EMPRESAS E INSTITUCIONES DEL GRUPO POR UN PAÍS MEJOR
                </h1>
                <p> Grupo Por Un País Mejor (GPUPM) está conformado por empresas de tipo comercial e instituciones de carácter social, todas encaminadas a construir una nación más justa y equitativa para todos los mexicanos. Te invitamos a conocer cada una y descubrir los grandes retos que tenemos por cumplir.</p>
            </div>
            <div class="dCinco dtDos dmMedio"></div>
        </div>
    </header>
</div>

<div class="FlgsSld dNueve dtDiez dmOnce">
    <div class="FlgsSldInt flx">
        <div class="dCuatro dtSeis dmDoce">
        <a href="https://www.porunpaismejor.com.mx/" target="_blank" rel="noopener">
            <img class="boxshaw" src="./assets/images/ligas-gpupm-new.jpg" alt="Grupo Por Un País Mejor">
            <div>
                <p>Grupo Por Un País Mejor</p> 
            </div>
        </a>
        </div>
        <div class="dCuatro dtSeis dmDoce">
        <a href="https://www.ssdrsimi.com.mx/" target="_blank" rel="noopener">
            <img class="boxshaw" src="./assets/images/ligas-analisis-clinicos-new.jpg" alt="Análisis Clínicos del Dr. Simi">
            <div>
                <p> Análisis Clínicos del Dr. Simi </p> 
            </div>
        </a>
        </div>

        <div class="dCuatro dtSeis dmDoce Fblanco">
        <a href="https://simisae.com.mx/" target="_blank" rel="noopener">
            <img class="boxshaw" src="./assets/images/ligas-simisae-new.jpg" alt="Simisae Centro simi de salud emocional">
            <div>
                <p>SIMISAE Centro Simi de Salud Emocional</p> 
            </div>
        </a>
        </div>
        <div class="dCuatro dtSeis dmDoce Fblanco">
        <a href="http://www.fundaciondrsimi.org.mx/" target="_blank" rel="noopener">
            <img class="boxshaw" src="./assets/images/ligas-fundacionsimi-new.jpg" alt="Fundación del Doctor Simi">
            <div>
                <p> Fundación del Doctor Simi </p>
            </div>
        </a>
        </div>
        <div class="dCuatro dtSeis dmDoce Fblanco">
        <a href="https://www.fundacioneugenia.org.mx/" target="_blank" rel="noopener">
            <img class="boxshaw" src="./assets/images/ligas-eugenia-new.jpg" alt="Fundación Niños de Eugenia">
            <div>
                <p> Fundación Niños de Eugenia </p>
            </div>
        </a>
        </div>

        <div class="dCuatro dtSeis dmDoce">
        <a href="http://www.laboratoriosbest.com.mx/" target="_blank" rel="noopener">
            <img class="boxshaw" src="./assets/images/ligas-laboratorios-new.jpg" alt="Laboratorios Best">
            <div>
                <p> Laboratorios Best </p>
            </div>
        </a>
        </div>
        <div class="dCuatro dtSeis dmDoce">
            <a href="https://farmaciasdesimilares.com/" target="_blank" rel="noopener">
               <img class="boxshaw" src="./assets/images/ligas-f-similares-new.jpg" alt="Farmacias Similares">
               <div>
                   <p> Farmacias Similares </p> 
               </div>
           </a>
        </div>
        <div class="dCuatro dtSeis dmDoce">
            <a href="https://simipet.mx/" target="_blank" rel="noopener">
               <img class="boxshaw" src="./assets/images/ligas-simipet-new.jpg" alt="Farmacias Similares">
               <div>
                   <p> SimiPet </p> 
               </div>
           </a>
        </div>
    </div>
</div>

</div>